import { throttle } from 'throttle-debounce';

export default function searchInputs() {
    const searchWraps = document.querySelectorAll('.js--search');

    searchWraps.forEach((wrap) => {
        const input = wrap.querySelector('.input__field');
        const clearBtn = wrap.querySelector('.input__clear-btn');

        input.addEventListener('input', throttle(750, () => {
            if (input.value.trim().length === 0) input.value = '';
            if (input.value.length > 0) {
                wrap.classList.remove('is-empty');
            } else {
                wrap.classList.add('is-empty');
            }
        }));

        clearBtn.addEventListener('click', () => {
            input.value = '';
            wrap.classList.add('is-empty');
        });
    });
}
